import { useState, useEffect, useCallback } from "react";
import { Star, Loader2, Library } from "lucide-react";
import { PokemonCardTile } from "./PokemonCardTile";
import { makeVariant } from "../lib/variants";
import { fetchWantedCards } from "../lib/api";

// Vue « Cartes recherchées » : la liste d'envies, toutes collections
// confondues. Une carte y apparaît une fois par variante recherchée (on peut
// vouloir la reverse sans vouloir la normale), d'où `wanted_variant`.
//
// Le contenu se recharge à chaque ouverture ET après chaque changement de
// statut : décocher une carte doit la faire disparaître tout de suite, sinon
// on resterait devant une liste qui ment.
export const WantedView = ({
  collection, conditions = {}, onStatusChange, onRemove, onCardClick,
}) => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(() => {
    setLoading(true);
    fetchWantedCards()
      .then(setCards)
      .catch(err => console.error("Cartes recherchées :", err))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const handleVariantClick = async (cardId, variantType, currentStatus, shiftKey) => {
    if (shiftKey) {
      if (currentStatus === "wanted") await onRemove(cardId, variantType);
      else await onStatusChange(cardId, variantType, "wanted");
    } else {
      if (!currentStatus || currentStatus === "wanted") await onStatusChange(cardId, variantType, "owned");
      else await onRemove(cardId, variantType);
    }
    reload();
  };

  if (loading) {
    return <div className="flex justify-center py-20"><Loader2 className="w-10 h-10 animate-spin text-red-500" /></div>;
  }

  return (
    <div>
      <h2 className="text-2xl font-bold text-white mb-1 flex items-center gap-2">
        <Star className="w-6 h-6 text-blue-400" />Cartes recherchées
        <span className="text-base font-normal text-zinc-500">({cards.length})</span>
      </h2>
      <p className="text-sm text-zinc-500 mb-5">
        Maj+clic sur un badge de variante depuis n'importe quelle vue pour ajouter une carte ici.
        Un clic simple la fait passer en « possédée » et la retire de cette liste.
      </p>

      {cards.length === 0 ? (
        <div className="text-center py-16 text-zinc-500">
          <Library className="w-12 h-12 mx-auto mb-4 opacity-50" />
          <p>Aucune carte recherchée pour l'instant.</p>
        </div>
      ) : (
        <div className="card-grid">
          {cards.map(card => (
            <PokemonCardTile
              key={`${card.id}::${card.wanted_variant}`}
              card={card}
              collectionMap={collection}
              conditionMap={conditions}
              onCardClick={onCardClick}
              onVariantClick={handleVariantClick}
              cardVariants={[makeVariant(card.wanted_variant)]}
            />
          ))}
        </div>
      )}
    </div>
  );
};
